<template>
  <div class="agreement">
    <div class="btnbox">
      <el-button class="add-btn" @click="add" icon="el-icon-plus"
        >添加协议</el-button
      >
    </div>
    <div class="content">
      <el-table
        :data="tableData"
        tooltip-effect="dark"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
      >
        <el-table-column
          type="index"
          width="100"
          label="编号"
        ></el-table-column>
        <el-table-column prop="agreementName" label="协议名称">
        </el-table-column>
        <el-table-column prop="createdTime" label="创建时间"> </el-table-column>
        <el-table-column prop="updatedTime" label="修改时间"> </el-table-column>
        <el-table-column prop="cityPathName" label="状态">
          <template slot-scope="{ row }">
            <!-- <span :style="{ color: row.isDel === 0 ? '#5E83F5' : '#EE4242' }">{{
              row.isDel === 0 ? "使用中" : "已删除"
            }}</span> -->
            <el-button class="blue-btn" v-if="row.isDel === 0"
              >使用中</el-button
            >
          </template>
        </el-table-column>
        <el-table-column prop="language" label="语言">
          <template slot-scope="{ row }">
            <el-button
              v-if="row.language === 'zh'"
              class="textBlue-btn"
              type="text"
              >{{ row.language_dictText }}</el-button
            >
            <el-button v-else class="textOrange-btn" type="text">{{
              row.language_dictText
            }}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="内容">
          <template slot-scope="{ row }">
            <el-button class="textOrange-btn" type="text" @click="checkImg(row)"
              >查看</el-button
            >
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              class="textOrange-btn"
              type="text"
              @click="checkDetail(scope.row)"
              >编辑</el-button
            >
            <el-popconfirm
              title="确认删除该协议吗？"
              popper-class="customerdel-popover"
              @confirm="cancelOrder(scope.row)"
            >
              <el-button class="textOrange-btn" slot="reference"
                >删除</el-button
              >
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <pagination
        v-show="total > queryParams.pageSize"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="init"
      />
    </div>
    <!-- 查看内容 -->
    <el-dialog
      :visible.sync="IMgdialogVisible"
      title="内容"
      width="70%"
      :before-close="handleClose"
      destroy-on-close
      :show-close="false"
      top="8vh"
    >
      <div slot="title" class="title">
        <p>查看协议内容</p>
        <span @click="handleClose"><i class="el-icon-close"></i></span>
      </div>
      <div class="agree-content">
        <div v-html="ruchContent"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getAgreementList, deleteAgreement } from "@/api/login";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
export default {
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
      tableData: [],
      total: 0, //总数
      ruchContent: null,
      IMgdialogVisible: false,
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    //获取协议列表
    async init() {
      const res = await getAgreementList(this.queryParams);
      this.tableData = res.result.records;
      this.total = res.result.total;
    },
    // 查看内容
    checkImg(obj) {
      this.ruchContent = obj.info;
      this.IMgdialogVisible = true;
    },
    handleClose() {
      this.IMgdialogVisible = false;
    },
    // 删除协议
    async cancelOrder(item) {
      // console.log(item, status, index);
      const params = {
        agreementName: item.agreementName,
        id: item.id,
        language: item.language,
      };
      await deleteAgreement(params);
      this.$message.success("协议删除成功");
      // this.$refs[`popover-${index}`].doClose();
      this.init();
    },
    // 编辑
    checkDetail(row) {
      this.$router.push({
        path: "/newagreement",
        query: {
          id: row.id,
          name: row.agreementName,
          language: row.language,
        },
      });
    },
    // 添加
    add() {
      this.$router.push({
        path: "/newagreement",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.agreement {
  position: relative;
  .btnbox {
    position: absolute;
    top: -88px;
    right: 0;
  }
  .content {
    .logo {
      display: flex;
      justify-content: center;
      img {
        width: 50px;
        height: 50px;
      }
    }
  }
  ::v-deep(.el-dialog) {
    .el-dialog__body {
      display: flex;
      align-items: center;
      justify-content: center;
      .agree-content {
        max-height: 500px;
        overflow-y: scroll;
      }
      .OutBtnBox {
        margin-top: 10px;
        text-align: center;
      }
    }
  }
  .textOrange-btn {
    padding: 0 5px;
  }
}
</style>
